import { useMemo } from 'react'

import { Edge, Node } from 'reactflow'
import 'reactflow/dist/style.css'

import { OriginItem } from '../../../pages/OriginItems/origin-items.types'
import { NextItemNode } from '../components/NextItemNode'

const OriginItemNode = (props: any) => (
  <NextItemNode allowEdditing={false} {...props} />
)

const getInitialData = (
  item: OriginItem,
  parentId?: string,
  nodes: Node<any>[] = [],
  edges: Edge<any>[] = [],
) => {
  nodes.push({
    id: item.nodeId ?? '',
    position: { x: 0, y: 0 },
    data: {
      ...item,
    },
    selectable: false,
    type: parentId && !item.id ? 'custom' : 'default',
  })

  if (parentId) {
    edges.push({
      id: `e-${parentId}-${item.nodeId ?? ''}`,
      source: parentId,
      target: item.nodeId ?? '',
      animated: true,
      style: { stroke: '#c8c8c8', strokeWidth: 2 },
    })
  }

  if (item.originItems && item.originItems.length > 0) {
    item.originItems.forEach((child) => {
      getInitialData(child, item.nodeId, nodes, edges)
    })
  }

  return { nodes, edges }
}
interface IUseOriginTree {
  originItem: OriginItem
}
export const useOriginItemTree = ({ originItem }: IUseOriginTree) => {
  const initialData = useMemo(() => {
    if (originItem) {
      return getInitialData(originItem)
    }
    return {
      nodes: [],
      edges: [],
    }
  }, [originItem])

  const { nodes: initialNodes, edges: initialEdges } = initialData

  const nodeTypes = useMemo(
    () => ({ default: OriginItemNode, custom: NextItemNode }),
    [],
  )

  return {
    initialNodes,
    initialEdges,
    nodeTypes,
  }
}
